import { useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import Routes from 'routes';
import ThemeCustomization from 'themes';
import { AuthProvider } from 'contexts/AuthContext';

const App = () => {
  // A 401 already ends the session in the axios interceptor, so retrying it is pointless.
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: { queries: { retry: (count, err: any) => err?.status !== 401 && err?.status !== 404 && count < 1 } }
      })
  );

  return (
    <ThemeCustomization>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <Routes />
        </AuthProvider>
      </QueryClientProvider>
    </ThemeCustomization>
  );
};

export default App;
